import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExportJobNotificationService {
    private exportReady$ = new Subject<string>();
    readonly exportReady = this.exportReady$.asObservable();

    notifyExportReady(jobId: string): void {
        this.exportReady$.next(jobId);
    }
}
